import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ extension, ...args }) {
    super(args)
    const child = this.getComponentWithVModel('image-input')
    child.attrs.extension = extension
    this.children = [child]
  }
}
